import Action from 'actions';
import BaseExecutor from 'services/sports/default/base-executor';
import BaseValidator from 'services/validations/base-validator';
import MinMaxCombinationsPercentValidator from 'components/organisms/non-controlled-hitter-stacking/validators/min-max-combinations-percent-validator';
import AtLeastOneCombinationWasChosenValidator from 'components/organisms/non-controlled-hitter-stacking/validators/at-least-one-combination-was-chosen-validator';
import AtLeastOneTeamWasChosenForEachStackValidator from 'components/organisms/non-controlled-hitter-stacking/validators/at-least-one-team-was-chosen-for-each-stack-validator';
import AtLeastOneTeamWithExposureMoreThanZeroValidator from 'components/organisms/non-controlled-hitter-stacking/validators/at-least-one-team-with-exposure-more-than-zero-validator';
import AtLeastOneBattingOrderWasChosenForEachStackValidator from 'components/organisms/non-controlled-hitter-stacking/validators/at-least-one-batting-order-was-chosen-for-each-stack-validator';
import OneTheSameTeamWasChosenForBothStacksValidator from 'components/organisms/non-controlled-hitter-stacking/validators/one-the-same-team-was-chosen-for-both-stacks-validator';
import MinExposureValidator from 'components/organisms/non-controlled-hitter-stacking/validators/min-exposure-validator';

class NonControlledHitterStackingValidatorBuilder extends BaseExecutor {
    getInterface() {
        const {
            nonControlledHitterStacking: {settings: stacking},
        } = Action.getState();

        const validator = new BaseValidator();

        if (!stacking.isEnabled()) {
            return validator;
        }

        const minMaxCombinationsPercentValidator = new MinMaxCombinationsPercentValidator();
        minMaxCombinationsPercentValidator.setDependencies({stacking});

        const atLeastOneCombinationWasChosenValidator = new AtLeastOneCombinationWasChosenValidator();
        atLeastOneCombinationWasChosenValidator.setDependencies({stacking});

        const atLeastOneTeamWasChosenForEachStackValidator = new AtLeastOneTeamWasChosenForEachStackValidator();
        atLeastOneTeamWasChosenForEachStackValidator.setDependencies({stacking});

        const oneTheSameTeamWasChosenForBothStacksValidator = new OneTheSameTeamWasChosenForBothStacksValidator();
        oneTheSameTeamWasChosenForBothStacksValidator.setDependencies({stacking});

        const atLeastOneTeamWithExposureMoreThanZeroValidator = new AtLeastOneTeamWithExposureMoreThanZeroValidator();
        atLeastOneTeamWithExposureMoreThanZeroValidator.setDependencies({stacking});

        const atLeastOneBattingOrderWasChosenForEachStackValidator =
            new AtLeastOneBattingOrderWasChosenForEachStackValidator();
        atLeastOneBattingOrderWasChosenForEachStackValidator.setDependencies({stacking});

        const minExposureValidator = new MinExposureValidator();
        minExposureValidator.setDependencies({stacking});

        validator.addSubValidators([
            minMaxCombinationsPercentValidator,
            atLeastOneCombinationWasChosenValidator,
            atLeastOneTeamWasChosenForEachStackValidator,
            atLeastOneTeamWithExposureMoreThanZeroValidator,
            atLeastOneBattingOrderWasChosenForEachStackValidator,
            oneTheSameTeamWasChosenForBothStacksValidator,
            minExposureValidator,
        ]);

        return validator;
    }
}

export {NonControlledHitterStackingValidatorBuilder};
